import { FIELDS, MAX_TAGS } from "apps/nonbinary/util/constants";


function warn(message) {
	if (process.env.NODE_ENV === "test") {
		return;
	}

	console.warn(message);
}


// ////////////////////////
// ACTION TYPES //////////
// //////////////////////

export const OPEN = "NONBINARY.OPEN";
export const ADD_TAG = "NONBINARY.ADD_TAG";
export const REMOVE_TAG = "NONBINARY.REMOVE_TAG";
export const SET_TAGS = "NONBINARY.SET_TAGS";
export const SET_UNDERLYING = "NONBINARY.SET_UNDERLYING";
export const SAVE = "NONBINARY.SAVE";
export const CANCEL = "NONBINARY.CANCEL";
export const RESET = "NONBINARY.RESET";



// ////////////////////////
// INITIAL STATE /////////
// //////////////////////

export const INITIAL_STATE = {
	activeField: null,
	availableTags: {},
	selectedTags: {},
	startingTags: {},
	availableUnderlying: {},
	selectedUnderlying: {},
	error: null,
};

// Scaffold up fields
FIELDS.forEach((key) => {
	INITIAL_STATE.availableTags[key] = [];
	INITIAL_STATE.selectedTags[key] = [];
	INITIAL_STATE.startingTags[key] = [];
	INITIAL_STATE.availableUnderlying[key] = [];
	INITIAL_STATE.selectedUnderlying[key] = null;
});


// Pull in initial state from the window, if provided
const initialState = typeof window !== "undefined" && window.NonbinaryParams ?
	{ ...INITIAL_STATE, ...window.NonbinaryParams } :
	INITIAL_STATE;


// ////////////////////////
// REDUCER ///////////////
// //////////////////////

export function reducer(state = initialState, action) {
	// Early exit for a bad field.
	if (action.type && action.type.indexOf("NONBINARY") === 0) {
		if (action.field && FIELDS.indexOf(action.field) === -1) {
			warn(`Unknown field '${action.field}' passed to '${action.type}'`);
			return state;
		}
	}

	switch (action.type) {
		case OPEN: {
			const startingTags = state.startingTags;
			startingTags[action.field] = state.selectedTags[action.field].slice();

			return {
				...state,
				startingTags,
				activeField: action.field,
			};
		}


		// a wholesale setter that adds multiple tags at a time and blows away
		// whatever may have been set
		case SET_TAGS: {
			if (!action.field || FIELDS.indexOf(action.field) === -1) {
				return state;
			}

			const tags = state.availableTags[action.field].filter((tag) => {
				return action.ids.indexOf(tag.id) !== -1;
			});

			// if the action has tags on it, but none match the available tags,
			// short circuit with no modifications
			if (action.ids.length && !tags.length) {
				return state;
			}

			const selectedTags = {
				...state.selectedTags,
				[action.field]: tags,
			};

			return {
				...state,
				selectedTags,
			};
		}


		case ADD_TAG:
		case REMOVE_TAG: {
			// Early exit for bad tag id
			const tag = state.availableTags[action.field].find((t) => t.id === action.id);

			if (!tag) {
				warn(`Tried to perform '${action.type}' on unknown tag '${action.id}'`);
				return state;
			}

			// Early exit for too many tags
			if (action.type === ADD_TAG && state.selectedTags[action.field].length >= MAX_TAGS) {
				return state;
			}

			// Add / remove the tag if it's good
			const selectedTags = { ...state.selectedTags };
			const newTags = selectedTags[action.field].slice();
			const idx = newTags.map((t) => t.id).indexOf(action.id);

			if (action.type === ADD_TAG && idx === -1) {
				newTags.push(tag);
			}
			else if (action.type === REMOVE_TAG && idx !== -1) {
				newTags.splice(idx, 1);
			}

			selectedTags[action.field] = newTags;

			return {
				...state,
				selectedTags,
			};
		}


		case SET_UNDERLYING: {
			let isValid = false;
			const options = state.availableUnderlying[action.field];

			if (options.length) {
				options.forEach((option) => {
					if (option.id === action.id || action.id === "false") {
						isValid = true;
					}
				});
			}

			if (!isValid) {
				return state;
			}

			return {
				...state,
				error: action.error,
				selectedUnderlying: {
					...state.selectedUnderlying,
					[action.field]: action.id,
				},
			};
		}


		case SAVE:
			return {
				...state,
				activeField: null,
			};


		case CANCEL:
			return {
				...state,
				selectedTags: {
					...state.startingTags,
				},
				activeField: null,
			};

		case RESET:
			return {
				...state,
				selectedTags: {
					...state.selectedTags,
					[action.field]: [],
				},
				selectedUnderlying: {
					...state.selectedUnderlying,
					[action.field]: null,
				},
			};

		default:
			return state;
	}
}



// ////////////////////////
// ACTION CREATORS ///////
// //////////////////////

export function open(field) {
	return {
		type: OPEN,
		field,
	};
}

export function setTags(ids, field) {
	return {
		type: SET_TAGS,
		field,
		ids,
	};
}

export function addTag(id, field) {
	return {
		type: ADD_TAG,
		id,
		field,
	};
}

export function removeTag(id, field) {
	return {
		type: REMOVE_TAG,
		id,
		field,
	};
}

export function setUnderlying(field, id) {
	let message = null;

	if (id === "false") {
		message = "Please select an option";
	}

	return {
		type: SET_UNDERLYING,
		field,
		error: message,
		id,
	};
}

export function save() {
	return (dispatch, getState) => {
		const state = getState().nonbinary;

		dispatch({
			type: SAVE,
			activeField: state.activeField,
			tags: {
				gender: state.selectedTags.gender,
				orientation: state.selectedTags.orientation,
			},
			underlying: {
				gender: state.selectedUnderlying.gender,
				orientation: state.selectedUnderlying.orientation,
			},
		});
	};
}

export function cancel() {
	return { type: CANCEL };
}

export function reset(field) {
	return {
		type: RESET,
		field,
	};
}



// WEBPACK FOOTER //
// ./src/ducks/nonbinary.js